import { getLsItem } from '~/utils/localStorage'

import type { Session } from '../@types'
import { SESSION_LS_KEY } from '../constants'

export const getSessionLsItem = () => {
  return getLsItem<Session>(SESSION_LS_KEY)
}
